module.exports = __webpack_public_path__ + "img/coreintercom.63fac856.png";